export const SET_LIST_MACRO_CATEGORY = "SET_LIST_MACRO_CATEGORY";
export const SET_LIST_CATEGORY = "SET_LIST_CATEGORY";
export const SET_LIST_MACRO_CATEGORY_TOTAL = "SET_LIST_MACRO_CATEGORY_TOTAL";